/**
 * エラー文言
 */
export const ERR_INVALID_USER = "メールアドレスまたは、パスワードが正しくありません。";
export const ERR_USER_LOCKED = "アカウントが無効です。別のアカウントでログインしてください。";
export const ERR_INVALID_SERIAL = "シリアル番号が正しくありません。";
export const ERR_UNKNOWN = "現在、サービスを利用できません。";
export const ERR_DICTIONARY = "20文字以内の単語を指定してください。";
export const ERR_DICTIONARY_INPUT = "英単語を入力してください。";
export const ERR_DICTIONARY_INVALID_WORD = "該当する項目は見つかりませんでした。";
export const ERR_DICTIONARY_UNKNOWN = "エラーが発生しました。(x)";
export const ERR_TAKEOVER_PASSWORD = "英数半角4～16文字で入力して下さい。";
export const ERR_INVALID_TAKEOVER = "引継ぎコードまたは、パスワードが正しくありません。";

/**
 * Error.vueのbuttonKind
 */
export const ERROR_BUTTON_KIND_LOGIN = "login";

/**
 * 非表示コンテンツ　コンテンツIDを指定するとストア/学習一覧共に非表示になる
 */
export const INVISIBLE_CONTENTS = {
  // 本番環境
  production: {
    // PC版
    pc: [
    ],
    // モバイルアプリ版
    mobile: [
    ]
  },
  // ステージング環境
  staging: {
    // PC版
    pc: [
    ],
    // モバイルアプリ版
    mobile: [
    ]
  }
};

/**
 * モバイル側JavaScriptインタフェース名
 */
export const MOBILE_INTERFACE_NAME = "Phone";

/**
 * プラットフォーム名
 */
// Android
export const PLATFORM_ANDROID = "android";
// Docomo
export const PLATFORM_DOCOMO = "docomo";
// au
export const PLATFORM_AU = "au";
// Softbank
export const PLATFORM_SOFTBANK = "softbank";
// ライブラリ
export const PLATFORM_LIBRARY = "library";
// iOS
export const PLATFORM_IOS = "ios";

/**
 * モバイルアプリの最新version
 * アップデート通知ダイアログの表示判定に使用
 */
// ライブラリ版Android
export const VERSION_LIBRARY_ANDROID = 33;
// ドコモBasic版Android
export const VERSION_DOCOMO_ANDROID = 28;
// au版Android
export const VERSION_AU_ANDROID = 14;
// ライブラリ版iOS
export const VERSION_LIBRARY_IOS_MAJOR = 1;
export const VERSION_LIBRARY_IOS_MINOR = 12;
export const VERSION_LIBRARY_IOS_REV = 0;

/**
 * Basicドコモ版Androidアプリ表示コンテンツ
 */
export const CONTENTS_DOCOMO_ANDROID = [
  // // 開発用
  // '{63FC5790-E902-4670-9152-54FEFE71B195}',
  // '{BF027C21-7948-422F-A2B7-EB7602AE5A33}',
  // '{477A5521-B1E0-4D7E-A885-60A1C8B5D6D5}',
  // '{ADE5EA47-8C13-4454-89B7-468812007A69}',
  // '{0212E461-A056-41FC-90EC-9A99F0CD4DD4}',
  // '{7898C2C3-4828-40C0-AE4F-4691C8990C1E}',
  // ステージング用
  "{F5DCDD19-86A1-4FE9-99EF-E58B32F037C3}",
  "{B1D698F8-C5EA-441E-BD51-32C2A769890F}",
  "{B61EA01B-639A-4648-8F33-C7F9881034DA}",
  "{11E821B9-D69C-4150-A09B-DEB71738E64B}",
  "{969232A2-5728-4BC2-88EE-0202C2AD09C0}",
  "{39E168F8-0C2C-4C4E-8DDA-74AB649AFE81}",
  "{5751F7DB-E66C-4469-B6F8-33E5A8792560}"
];

/**
 * au版Androidアプリ表示コンテンツ
 */
export const CONTENTS_AU_ANDROID = [
  "{F5DCDD19-86A1-4FE9-99EF-E58B32F037C3}",
  "{53CEC564-04CC-44BE-994F-C72EE018684B}"
];

/**
 * パッケージ名
 */
// Basicドコモ版Androidアプリ
export const PACKAGE_DOCOMO_ANDROID = "com.sourcenext.android.docomo.rosettastone.basic";
// au版Androidアプリ
export const PACKAGE_AU_ANDROID = "com.sourcenext.android.kddi.rosettastone.";
// softbank版Androidアプリ
export const PACKAGE_SOFTBANK_ANDROID = "com.mobiroo.n.sourcenextcorporation.rosetta_";
// ライブラリ版Androidアプリ
export const PACKAGE_LIBRARY_ANDROID = "com.sourcenext.android.rosettastone";

/**
 * コンテンツのGUID
 */
// 英語 プライベート Vol.1
export const CONTENTS_ID_PRIVATE1 = "{53CEC564-04CC-44BE-994F-C72EE018684B}";
// 英語 プライベート Vol.2
export const CONTENTS_ID_PRIVATE2 = "{D1FEE94C-0CB4-4D39-8D5A-4F7FB7ADC55B}";
// 英語　ビジネス Vol.1
export const CONTENTS_ID_BUSINESS1 = "{F3DFD2D5-8B3C-4F60-ACC1-DA548EAB4846}";
// 英語 ビジネス Vol.2
export const CONTENTS_ID_BUSINESS2 = "{278E35D4-E8CD-4B54-90FD-F0FF5047218A}";
// 英語 ビジネス Vol.3
export const CONTENTS_ID_BUSINESS3 = "{BEE07EA8-5DF4-4DC4-93CD-27EB8EEE036B}";
// 至高の模試
export const CONTENTS_ID_TOEIC = "{A1B2E0BB-FFDF-4E4A-99DB-5056D80654E2}";
// キクタン500
export const CONTENTS_ID_KIKUTAN500 = "{AC8C293F-2C6D-4A23-BAAD-496308C07945}";
// キクタン600
export const CONTENTS_ID_KIKUTAN600 = "{1DBFED3E-0194-49B3-A0FE-F853F23F8911}";
// キクタン800
export const CONTENTS_ID_KIKUTAN800 = "{22CE693B-CF34-40AF-8011-D3770E960071}";
// キクタン990
export const CONTENTS_ID_KIKUTAN990 = "{0C905E19-9347-4C27-8743-D9608C98D1AF}";
// ロゼッタストーンBasic版 英語(アメリカ)
export const CONTENTS_ID_EN_US = "{F5DCDD19-86A1-4FE9-99EF-E58B32F037C3}";
// ロゼッタストーンBasic版 フランス語
export const CONTENTS_ID_FR = "{B1D698F8-C5EA-441E-BD51-32C2A769890F}";
// ロゼッタストーンBasic版 イタリア語
export const CONTENTS_ID_IT = "{B61EA01B-639A-4648-8F33-C7F9881034DA}";
// ロゼッタストーンBasic版 スペイン語(スペイン)
export const CONTENTS_ID_ES_ES = "{11E821B9-D69C-4150-A09B-DEB71738E64B}";
// ロゼッタストーンBasic版 ドイツ語
export const CONTENTS_ID_DE = "{969232A2-5728-4BC2-88EE-0202C2AD09C0}";
// ロゼッタストーンBasic版 中国語(マンダリン)
export const CONTENTS_ID_ZH_CN = "{39E168F8-0C2C-4C4E-8DDA-74AB649AFE81}";
// ロゼッタストーンBasic版 韓国語
export const CONTENTS_ID_KO_KR = "{5751F7DB-E66C-4469-B6F8-33E5A8792560}";
// ロゼッタストーンBasic版 英語(イギリス)
export const CONTENTS_ID_EN_GB = "{C6C03343-CA6E-4F78-AB6A-F5F79BBA830D}";
// ロゼッタストーンBasic版 アイルランド語
export const CONTENTS_ID_GA_IE = "{FFA5DA4D-A729-4DD7-BA87-59ED6DF29969}";
// ロゼッタストーンBasic版 アラビア語
export const CONTENTS_ID_AR = "{12AB6794-19A5-4DF1-9027-A2C4C787AB9D}";
// ロゼッタストーンBasic版 オランダ語
export const CONTENTS_ID_NL = "{6393F594-264D-4C55-8FF0-0E9DB5C19319}";
// ロゼッタストーンBasic版 ギリシャ語
export const CONTENTS_ID_EL_GR = "{8A880A2E-AA98-4263-B987-18E3B7EFEC28}";
// ロゼッタストーンBasic版 スウェーデン語
export const CONTENTS_ID_SV_SE = "{0015FD9F-312F-45FD-AD7A-5FFAE0A41751}";
// ロゼッタストーンBasic版 スペイン語(ラテンアメリカ)
export const CONTENTS_ID_ES_419 = "{07141570-ECB1-48FD-BF0E-E17D3CB2F8A9}";
// ロゼッタストーンBasic版 トルコ語
export const CONTENTS_ID_TR = "{032B6615-4C40-4C76-8D1C-859B61CE64C4}";
// ロゼッタストーンBasic版 日本語
export const CONTENTS_ID_JA_JP = "{9B9537F0-4288-4986-BAF2-FEAFADB0EDC6}";
// ロゼッタストーンBasic版 ロシア語
export const CONTENTS_ID_RU = "{E17765BE-741E-405B-8054-D132C0D63FEF}";
// ロゼッタストーンBasic版 ヒンディー語
export const CONTENTS_ID_HI_IN = "{71C13FA7-95EE-4349-A503-F1C8E3F22092}";
// ロゼッタストーンBasic版 フィリピン語(タガログ語)
export const CONTENTS_ID_TL_PH = "{781CC166-DABA-4C37-B420-F751A70143CC}";
// ロゼッタストーンBasic版 ベトナム語
export const CONTENTS_ID_VI_VN = "{EE2FB87A-BE71-4FF0-B805-BDEBB4F57146}";
// ロゼッタストーンBasic版 ヘブライ語
export const CONTENTS_ID_HE_IL = "{12DEFF98-90DA-4F21-9FCE-7D4B04E04908}";
// ロゼッタストーンBasic版 ペルシア語(ファルシ語)
export const CONTENTS_ID_FA_IR = "{7B75B3E2-3D47-45C1-9550-E6DD40BB9572}";
// ロゼッタストーンBasic版 ポーランド語
export const CONTENTS_ID_PL = "{3DE36689-D940-4B7E-9272-E1B1480A37B4}";
// ロゼッタストーンBasic版 ポルトガル語(ブラジル)
export const CONTENTS_ID_PT_BR = "{6FC9C825-A753-4934-BBEE-0BE47F7EE713}";

/**
 * iOS非表示コンテンツ
 */
export const INVISIBLE_CONTENTS_IOS = [
];


/**
 * au版アプリで実行時
 * "英語　中上級　プライベート　Vol.1"の名前
 */
export const AU_PRIVATE1_CONTENTS_NAME = "英語　日常会話　中上級<br>(プレミアム会員限定)";

/**
 * 変換対象のタグ一覧（辞書画面）
 */
export const DIC_CHANGE_TAG_LIST = [
  { tag: "ref", word: "【参照】" },
  { tag: "syn", word: "【同意語】" },
  { tag: "ant", word: "【反意語】" },
  { tag: "x", word: "【不適切な 表現】" }
];

/**
 * GoogleAnalyticsページビューフィールド設定値
 */
export const GA_PAGEVIEW = Object.freeze({
  TITLE: Object.freeze({
    LOGIN: "ログイン画面",
    ACTIVATE: "シリアル入力画面",
    DICTIONARY: "詳細辞書"
  }),
  PAGE: Object.freeze({
    LOGIN: "/login",
    ACTIVATE: "/activate",
    DICTIONARY: "/dictionary"
  })
});

/**
 * GoogleAnalyticsイベントフィールド設定値
 */
export const GA_EVENT = Object.freeze({
  GATEGORY: Object.freeze({
    LOGIN: "ログイン画面",
    ACTIVATE: "シリアル入力画面",
    HEADER: "ヘッダ",
    HELP: "?",
    LEARNING: "学習画面",
    LEARNING_DETAIL: "学習詳細画面",
    STORE: "ストア画面"
  }),
  ACTION: Object.freeze({
    SUCCESS: "成功",
    FAILURE: "失敗",
    CLICK: "押下"
  }),
  LABEL: Object.freeze({
    LOGIN: "ログイン",
    ACTIVATE: "次へ",
    HELP: "?",
    LEARNING: "学習",
    STORE: "ストア",
    DICTIONARY: "辞書",
    LOGOUT: "ログアウト",
    SUPPORT: "サポート",
    RESTORE: "購入を復元する",
    REGISTER_USER: "PCやAndroidと連携する",
    UNREGISTER_USER: "PCやAndroidとの連携を解除する"
  })
});

/**
 * GoogleAnalyticsイベントカテゴリに付与する文字列
 */
export const GA_EVENT_GATEGORY_WITH_STRING = Object.freeze({
  DOCOMO: "(docomo)",
  AU: "(au)"
});



// WEBPACK FOOTER //
// ./src/mixin/constants.js